// extracted by mini-css-extract-plugin
export default {"engagementIcon":"MediaIcon_engagementIcon__U6kiB"};